import { en as shared } from '@/modules/shared/locale/en';
import { en as payment } from '@/modules/payment/locale/en';
import { en as requests } from '@/modules/requests/locale/en';

const en = {
  shared,
  payment,
  requests,
};

export default en;
